module.exports = __webpack_public_path__ + "img/brl.6b17856c.svg";